<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2024-03-06 14:28:39
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-16 10:42:38
 * @FilePath: \jsczt_vue20240117\src\components\moblieTab.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="list">
    <ul v-if="listData.length > 0">
      <li v-for="(item, index) in listData" :key="index">
        <div v-if="!item.hasChild"  :class="activecloumn == item.classinfoid ? 'activecolumn' : ''" class="list_item" @click="gotoDetail(item)">
          <div class="list_txt">
            {{ item.cname }}
          </div>
          <div class="gobtn">
            <van-icon name="arrow" />
          </div>
        </div>
        <div v-else class="list_items" :class="activecloumn == item.classinfoid ? 'activecolumn' : ''">
          <div class="list_txt">
            {{ item.cname }}
          </div>
          <div class="child_box">
            <div
             @click="gotoDetail(itemc)"
              class="child_item"
              v-for="(itemc, indexc) in item.chlid"
              :key="indexc"
            >
              <div class="cicon">
                <van-icon name="play" color="#f4ba08" />
              </div>
              <div class="ctxt">{{ itemc.cname }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul v-else>
      <li>
        <div class="list_txt">暂无数据</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "moblieTab",
  props: {
    num: {
      type: [String,Number],
    },
  },
  data() {
    return {
      listData: [],
      listArray:[],
      activecloumn:6,
    };
  },
  watch: {},
  mounted() {
    // console.log(this.num);
    this.getTree();
  },
  watch: {
    num(newVal, oldVal) {
      // 当parentData变化时，这个函数会被调用
      // console.log(`parentData changed from ${oldVal} to ${newVal}`);
      this.num=newVal
      this.getList()
    },
  },
  methods: {
    async getTree() {
      await this.$http
        .get("/api/classinfo/getTree", {
          params: {
            topId: "2",
          },
        })
        .then((res) => {
          this.listArray=res.data.data.chlid
          this.getList()
        });
    },
    getList(){
      this.listArray.forEach((item) => {
            if (item.classinfoid == this.num) {
              this.listData = item.chlid;
              // return
            } else if (item.classinfoid == this.num) {
              this.listData = item.chlid;
              // return
            } else if (item.classinfoid == this.num) {
              this.listData = item.chlid;
              
              // return
            }
          });
          this.activecloumn=this.$store.state.sjclassinfoid;
    },
    gotoDetail(item) {
      // console.log(item)
      this.$http.post('/yjsUbas/yjs/add', {
      browserVersion:navigator.appVersion,
      browserName: navigator.appName,
      browserLanguage:navigator.language,
      areaCode:this.$store.state.code,
      areaName:this.$store.state.place,
      // deptCode:item.deptcode,
      // deptName:item.deptname,
      // unitCode:"",
      // unitName:"",
      areaYear:this.$store.state.year,
      sourceType:6,
      fileType:item.classinfoid,
      url:window.location.href
      // url:''
    }).then(res => {
      // if (res.data.code === 200) {
      //   this.listData = res.data.data
      // }
      })
      this.$store.commit('setSjName', item.cname);  
      this.$store.commit('setSjFileType', item.classinfoid);   
      this.$store.commit('setSjParentid', this.num);
      this.$router.push({ name: "moblieList" });
      
    },
  },
};
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}
ul li {
  list-style: none;
  margin-top: 10px;
}
.list_item,
.list_items {
  width: 95%;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #153a61;
  line-height: 40px;
  padding-left: 20px;
}
.list_item {
  height: 40px;
  display: flex;
}
.list_txt {
  flex: 8;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gobtn {
  flex: 1;
}
.list_items {
  padding: 15px 0px 15px 20px;
}
.child_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: -10px;
  margin-right: 20px;
}
.child_item {
  width: 48%;
  height: 30px;
  background: #f5f7f7;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #5e93bf;
  margin-top: 10px;
}
.cicon {
  margin-left: 5px;
}
.ctxt {
  margin-left: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.activecolumn{
  color:#5E93BF
}
</style>



// WEBPACK FOOTER //
// src/components/moblieTab.vue